import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import Root from '@/pages';

const FourOhFour = () => {
  return (
    <div className="bg-red-400">
      <h1>404</h1>
    </div>
  );
};

const router = createBrowserRouter(
  [
    {
      path: '*',
      element: <Root />,
      errorElement: <FourOhFour />,
      children: [
        {
          path: '',
          element: <Navigate to="/" replace />,
        },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);

export const AppRouterProvider = () => {
  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  );
};
